import utils from '../utils/utils'
import anime from '../libs/anime'
import globalVar from '../utils/globalVar'

class Home {
  constructor() {
    let scrollPos;
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
      scrollDetect();
    }

    let initCache = () => {
      cache.page = document.querySelector('.home');
      cache.slider = document.querySelector('.discover .slider');
      cache.foregroundImg = document.querySelector('.discover .foreground-img');
      cache.sliderBtn = document.querySelector('.discover .slider-button');

      if(document.querySelector('.anime-txt')) {
        cache.animeTxt = document.querySelectorAll('.anime-txt');
      }
      if(document.querySelector('.anime-img')) {
        cache.animeImg = document.querySelectorAll('.anime-img');
      }
      if(document.querySelector('.anime-titre')) {
        cache.animeTitre = document.querySelectorAll('.anime-titre');
      }
      if(document.querySelector('.anime-titre__no-overflow')) {
        cache.animeTitreOverflow = document.querySelector('.anime-titre__no-overflow');
      }
      if(document.querySelector('.anime-stagger')) {
        cache.animeStagger = document.querySelectorAll('.anime-stagger');
      }
    };

    let registerEvents = () => {
      window.addEventListener('scroll', scrollDetect);
      // cache.slider.addEventListener('input', slide);
    };

    // let slide = function(e) {
    //   const sliderPos = e.target.value;
    //   // Update the width of the foreground image
    //   cache.foregroundImg.style.width = sliderPos+"%";
    //   // Update the position of the slider button
    //   cache.sliderBtn.style.left = 'calc('+sliderPos+'% - 18px)';
    // }

    let scrollDetect = function() {
      let up = false;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;


// TEXTE
      if(document.querySelector('.anime-txt')) {
        for (let i = 0; i < cache.animeTxt.length; i++) {
          if(((scrollPos+(window.innerHeight/1.2)) > utils.getOffsetTop(cache.animeTxt[i])) && (!cache.animeTxt[i].classList.contains('animated'))){
            cache.animeTxt[i].classList.add('animated');
            anime({
              targets: cache.animeTxt[i],
              translateY: [50, 0],
              scale: [0.97, 1],
              opacity: [0,1],
              delay: (i * 50),
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// IMAGE
      if(document.querySelector('.anime-img')) {
        for (let i = 0; i < cache.animeImg.length; i++) {
          if(((scrollPos+(window.innerHeight/1.2)) > utils.getOffsetTop(cache.animeImg[i])) && (!cache.animeImg[i].classList.contains('animated'))){
            cache.animeImg[i].classList.add('animated');
            anime({
              targets: cache.animeImg[i],
              translateY: [50, 0],
              opacity: [0,1],
              scale: [0.95, 1],
              delay: (i * 50),
              duration: 800,
              easing: 'easeOutCirc',
            });
          }
        }
      }


// TITRE
      if(document.querySelector('.anime-titre')) {
        for (let i = 0; i < cache.animeTitre.length; i++) {
          if(((scrollPos+(window.innerHeight/1.2)) > utils.getOffsetTop(cache.animeTitre[i])) && (!cache.animeTitre[i].classList.contains('animated'))){
            cache.animeTitre[i].classList.add('animated');
            anime({
              targets: cache.animeTitre[i].querySelector('.inner'),
              translateY: ['215%', '0%'],
              rotate: [5, 0],
              skewX: [5,0],
              skewY: [5,0],
              delay: (200 + (i * 100)),
              duration: 800,
              easing: 'easeOutCirc',
              complete: function() {
                cache.animeTitreOverflow.style.overflow = 'inherit';
              }
            });
          }
        }
      }


    }

    initFunc();
  };
}
export { Home }
